import React, { useState } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import Icon from '@mdi/react';
import { withTranslation } from 'react-i18next';
import { Progress } from 'reactstrap';
import PropTypes from 'prop-types';
import { mdiPlayCircleOutline, mdiPauseCircleOutline } from '@mdi/js';
import SmartCard from '../../../shared/components/SmartCard';
import { UPLOAD_STATUS } from '../../../shared/utils/constants';

const UploadItem = (props) => {
  const {
    percentageValue,
    fileName,
    ownerName,
    status,
    t,
    preview,
    onClickButtonControlUpload,
  } = props;
  const [uploadPaused, setUploadPaused] = useState(false);

  const onClickFunctions = () => {
    onClickButtonControlUpload();
    setUploadPaused(!uploadPaused);
  };

  return (
    <MuiThemeProvider>
      <SmartCard>
        <div style={{ display: 'flex' }}>
          <div style={{ display: 'flex', flex: 1 }}>
            <video
              src={preview}
              controls
              style={{
                display: 'flex',
                flex: 1,
                maxWidth: 300,
                maxHeight: 160,
              }}
            >
              <track kind="captions" />
            </video>
          </div>
          <div
            style={{
              display: 'flex',
              flex: 2,
              flexDirection: 'column',
              paddingLeft: 20,
            }}
          >
            <div style={{ display: 'flex' }}>
              <h5>{fileName || 'SmartVideo'}</h5>
            </div>
            <div style={{ display: 'flex' }}>
              <h6>{ownerName}</h6>
            </div>
            <div style={{ display: 'flex' }}>
              {status === UPLOAD_STATUS.UPLOADING ? (
                <div className="progress-wrap">
                  <Progress animated value={percentageValue || 0} />
                </div>
              ) : (
                <h6>{t(`upload.status.${status}`)}</h6>
              )}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flex: 1,
              flexDirection: 'column',
              justifyContent: 'center',
              alignContent: 'center',
            }}
          >
            {status !== UPLOAD_STATUS.DONE ? (
              <Icon
                path={
                  uploadPaused ? mdiPlayCircleOutline : mdiPauseCircleOutline
                }
                size={1}
                onClick={onClickFunctions}
              />
            ) : null}
          </div>
        </div>
      </SmartCard>
    </MuiThemeProvider>
  );
};

UploadItem.propTypes = {
  t: PropTypes.func.isRequired,
  percentageValue: PropTypes.number.isRequired,
  fileName: PropTypes.string.isRequired,
  ownerName: PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
  preview: PropTypes.string.isRequired,
  onClickButtonControlUpload: PropTypes.func.isRequired,
};

export default withTranslation('common')(UploadItem);
